<div class="text" [hidden]="!text">{{text}}<span>.</span><span>.</span><span>.</span></div>
